import { Formik } from "formik";
import { Button, MenuItem } from "@mui/material";
import CustomField from "../shared/CustomTextField";
import Styles from "./Form.module.css";
import { postUser } from "../../utils/API/userMethods";
import { useStore } from "../../hooks/store";
import { userRole } from "../../utils/config";
import PasswTextField from "../shared/PasswTextField";

export default function NewUserForm() {
  const store = useStore();
  const { schoolList, defaultSelected } = store.form.dataToUpdate;

  const initValues = {
    name: null,
    description: null,
    login: null,
    role: "",
    password: null,
    password_confirm: null,
    school_id: 1,
  };

  const submitUser = (values) => {
    postUser(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        if (values.password != values.password_confirm || !values.password) {
          setErrors({
            password: "Пароли должны совпадать",
            password_confirm: "Пароли должны совпадать",
          });
          return;
        }
        submitUser({
          ...values,
          school_id: !!values.school_id ? values.school_id : null,
        });
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>Создание пользователя</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="name"
                  label="ФИО пользователя"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <CustomField
                  name="login"
                  label="Номер телефона "
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.login}
                />
                <CustomField
                  select
                  name="role"
                  label="Тип учетной записи"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.role}>
                  {Object.values(userRole)
                    .splice(1, 5)
                    .map((item, index) => (
                      <MenuItem value={index + 1}>{item}</MenuItem>
                    ))}
                </CustomField>
                <CustomField
                  // disabled={!schoolList}
                  disabled
                  select
                  name="school_id"
                  label="Выбор автошколы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.school_id}>
                  <MenuItem value={0}>Без автошколы</MenuItem>
                  {schoolList.map(({ id, name }) => {
                    return <MenuItem value={id}>"{name}"</MenuItem>;
                  })}
                </CustomField>
                <PasswTextField
                  error={errors.password}
                  type="password"
                  name="password"
                  label="Пароль"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                {/* <CustomField
                  type="password"
                  name="password_confirm"
                  label="Подтвердите пароль"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password_confirm}
                /> */}
                <PasswTextField
                  error={errors.password}
                  type="password"
                  name="password_confirm"
                  label="Подтвердите пароль"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password_confirm}
                />
                <span style={{ margin: "0 auto" }}>{errors.password}</span>
              </div>
            </div>

            <div className="form_actions">
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
